<template>
  <aside class="page-sidebar-mobile-container">
    <div
      class="page-sidebar-mobile-overlay"
      :class="{ active: show }"
      @click="setMenu(false)"
    ></div>

    <div
      class="page-sidebar-mobile d-flex flex-column d-lg-none"
      :class="{ active: show }"
    >
      <div class="header d-flex align-items-center">
        <b-avatar
          class="avatar"
          src="https://assets.admin.wize.pe/images/dropdown-user-avatar.svg"
        >
        </b-avatar>
        <div class="d-flex flex-column pl-3" v-if="user">
          <span class="user-name">{{ user.name }}</span>
          <span class="email d-inline-block mt-1">{{ user.email }}</span>
        </div>
      </div>

      <div class="grid mt-2 px-2" v-if="isAffiliate">
        <router-link
          :to="{ name: 'AffiliateDashboard' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'AffiliateDashboard' }"
        >
          <span class="menu-icon"><i class="ri-dashboard-line"></i></span>
          Dashboard
        </router-link>

        <router-link
          :to="{ name: 'AffiliateRides' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'AffiliateRides' }"
        >
          <span class="menu-icon"><i class="ri-car-line"></i></span>
          Mis Viajes
        </router-link>

        <router-link
          :to="{ name: 'AffiliatePassword' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'AffiliatePassword' }"
        >
          <span class="menu-icon"><i class="ri-lock-line"></i></span>
          Contrasena
        </router-link>
      </div>

      <div class="grid mt-2 px-2" v-else>
        <template v-for="item in menuItems">
          <!-- Ítem simple -->
          <router-link
            v-if="!item.children"
            :key="item.key"
            :to="{ name: item.route }"
            class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
            :class="{ active: $route.name == item.route }"
          >
            <span class="menu-icon">
              <i :class="item.icon"></i>
            </span>
            {{ item.text }}
          </router-link>

          <!-- Grupo con submenú -->
          <button
            v-else
            :key="item.key"
            type="button"
            class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
            :class="{ active: selection === item.key }"
            @click="setSelection(item.key)"
          >
            <span class="menu-icon">
              <i :class="item.icon"></i>
            </span>
            {{ item.text }}
          </button>
        </template>
      </div>

      <div class="menu-list-container">
        <ul class="menu-list list-unstyled" v-if="selection">
          <li v-for="item in getMenuItems" :key="item.text">
            <router-link
              :to="item.route"
              exact-active-class="active"
              class="menu-subitem text-decoration-none"
            >
              <BulletIcon class="fill-white mr-3" />{{ item.text }}
            </router-link>
          </li>
        </ul>
      </div>

      <button
        type="button"
        class="menu-option d-flex align-items-center"
        @click="logout()"
      >
        <i class="ri-logout-box-r-line"></i>
        <span class="sidebar-item-text">Cerrar sesión</span>
      </button>

      <div
        class="menu-option classic version d-flex justify-content-between align-items-center"
      >
        <span class="text">V{{ version }} {{ year }}</span>
        <p class="my-0">
          Forjado por <a href="https://wize.pe" target="_blank">Wize</a>
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { BulletIcon } from "wize-admin";
import { ADMIN_MENU, CITY_MENU } from "@/core/utils/menus";

export default {
  name: "PageSidebarMobile",
  components: { BulletIcon },
  props: {
    show: Boolean,
  },
  data() {
    return {
      version: process.env.PACKAGE_VERSION,
      year: new Date().getFullYear(),
      selection: "",
    };
  },
  mounted() {
    // Abre el submenú del grupo al que pertenece la ruta actual
    const group = this.menuItems.find(
      (item) =>
        item.children &&
        item.children.some((child) => child.route === this.$route.name)
    );
    if (group) this.setSelection(group.key);
  },
  watch: {
    "$route.name": function () {
      if (screen.width < 992) {
        this.setMenu(false);
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isMenuOpen: "app/isMenuOpen",
      isAffiliate: "auth/isAffiliate",
      isAdminLevel: "city/isAdminLevel",
    }),
    // Mismo origen de datos que el sidebar de escritorio (DEF-ADM-009)
    menuItems() {
      return this.isAdminLevel ? ADMIN_MENU : CITY_MENU;
    },
    getMenuItems() {
      const item = this.menuItems.find((i) => i.key === this.selection);
      return item && item.children
        ? item.children.map((c) => ({ route: { name: c.route }, text: c.text }))
        : [];
    },
  },
  methods: {
    ...mapMutations({
      setMenu: "app/setMenu",
    }),
    setSelection(key) {
      this.selection = key;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style lang="stylus">
@import "../../styles/components/layout/page-sidebar-mobile.styl"
</style>
